import axios from "axios"

const API_URL = process.env.REACT_APP_SERVER_URL

let user = JSON.parse(localStorage.getItem("user"))

let accessToken = user ? user.accessToken : null

const apiRefreshToken = (token = accessToken) => {

    const instance = axios.create({

        baseURL: API_URL,

        headers: {
            "Content-Type": "application/json",
            "x-access-token": token
        },

    })

    instance.interceptors.response.use(

        response => response,

        error => {

            if (!error.response && error.request) {

                console.log("AXIOS NETWORK ERROR")

                window.dispatchEvent(
                    new CustomEvent("axiosNetworkError")
                )
            }

            return Promise.reject(error)
        }

    )

    return instance
}

export default apiRefreshToken